import { Button, Heading, HStack, Icon, ModalBody, ModalHeader, Select, Text, VStack } from '@chakra-ui/react';
import InputComponent from '@components/Input';
import React, { useState } from 'react';
import { getRFIStatusColor } from '@views/RFITransactions/utils';
import { useDispatch } from 'react-redux';
import { updateRFIData } from '@store/actions/rfiActions';
import { RFI_CONSTANTS } from '@store/constants';
import { REJECTION_REASONS } from '@views/RFITransactions/constants';
import { IoArrowBackOutline } from 'react-icons/io5';


const UpdateModal = ({
  requestedItems,
  orderId,
  rfiType,
  askReason,
  status,
  onClose
}) => {
  const [reason, setReason] = useState(null);
  const [customReason, setCustomReason] = useState(null);

  const dispatch = useDispatch();

  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };
  const handleCustomReasonChange = (e) => {
    setCustomReason(e.target.value);
  };
  const isDisabled = () => {
    if (askReason === false) return false;
    if (reason !== REJECTION_REASONS.OTHER) {
      return !reason;
    }
    return !customReason?.trim();
  };

  const handleSave = () => {
    const rfiData = {
      rejectionReasons: reason,
      status: status,
      updatedItems: requestedItems
    };
    dispatch(
      updateRFIData({
        orderId,
        rfiType: rfiType,
        rfiData,
        onSuccess: (data) => {
          dispatch({
            type: RFI_CONSTANTS.UPDATE_RFI_SUCCESS,
            payload: { data }
          });
          onClose();
        }
      })
    );
  };

  return (
    <>
      <ModalHeader>
        <Heading size={'md'}>
          {`Update RFI: ${rfiType} for ${orderId} `}
        </Heading>
      </ModalHeader>
      <ModalBody pb={'2rem'}>
        <VStack alignItems={'start'} gap={4}>
          <HStack>
            <Text fontSize={'lg'}>RFI status will be updated to</Text>
            <HStack justifySelf={'center'}>
              <Icon
                viewBox="0 0 200 200"
                color={getRFIStatusColor(status)}
                w="8px"
              >
                <path
                  fill="currentColor"
                  d="M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"
                />
              </Icon>
              <Text fontSize={{ base: 'sm', sm: 'md' }} color="white">
                {status}
              </Text>
            </HStack>
          </HStack>
          {askReason &&
            (reason !== REJECTION_REASONS.OTHER ? (
              <Select placeholder="Enter Reason" onChange={handleReasonChange}>
                {Object.keys(REJECTION_REASONS).map((reason) => (
                  <option value={reason}>{reason}</option>
                ))}
              </Select>
            ) : (
              <InputComponent
                aria-label="Info"
                placeholder="Enter the reason for rejection"
                value={customReason}
                handleChange={handleCustomReasonChange}
                leftElementClickable={true}
                leftElement={
                  <IoArrowBackOutline
                    onClick={() => {
                      setReason(null);
                      setCustomReason(null);
                    }}
                  />
                }
                variant="brand"
                size="md"
              />
            ))}

          <Button
            colorScheme="brand"
            color={'black'}
            alignSelf="end"
            onClick={handleSave}
            isDisabled={isDisabled()}
          >
            Save RFI
          </Button>
        </VStack>
      </ModalBody>
    </>
  );
};

export default UpdateModal;
